import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { Button } from 'components/core/Button';
import { Link } from 'components/core/Link';
import Phone from 'components/svg/Phone';
import { phonePropType } from 'config/propTypes';

import './ClickToCall.scss';

export function ClickToCall({
	phone,
	onFetchNumber,
	phoneIcon = true,
	className,
	buttonText = 'Call to Book',
}) {
	const [fetched, setFetched] = useState(false);
	const handleFetchNumber = () => {
		if (isEmpty(phone)) {
			onFetchNumber();
		}
		setFetched(true);
	};
	return !phone || !fetched ? (
		<Button
			link
			onClick={handleFetchNumber}
			className={classnames('click-to-call', className)}
		>
			{phoneIcon && <Phone />} {buttonText}
		</Button>
	) : (
		<Link
			secondary
			href={`tel:${phone.number}`}
			className="click-to-call"
		>
			{phoneIcon && <Phone />} {phone.formattedNumber}
		</Link>
	);
}

ClickToCall.propTypes = {
	onFetchNumber: PropTypes.func.isRequired,
	phone: phonePropType,
	phoneIcon: PropTypes.bool,
	className: PropTypes.string,
	buttonText: PropTypes.string,
};

export default ClickToCall;
